import { render, staticRenderFns } from "./DemoCta.vue?vue&type=template&id=2bd83309&"
import script from "./DemoCta.vue?vue&type=script&lang=js&"
export * from "./DemoCta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports